module.exports = __webpack_public_path__ + "img/noti-close.f0212d50.svg";